import React from 'react';
import ReactDOM from 'react-dom/client';
import '@nemo/core/dist/nemo/nemo.css';
import { setAssetPath } from '@nemo/core/components';
import App from './App';
import { UserProvider } from './providers/UserContext';
import { MixpanelProvider } from './providers/MixpanelContext';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
setAssetPath(`${window.location.origin}/`);
root.render(
  <React.StrictMode>
    <MixpanelProvider>
      <UserProvider>
        <App />
      </UserProvider>
    </MixpanelProvider>
  </React.StrictMode>,
);
